import axios from "axios";

/**
 * POST /feedback body: a user's support/feedback note plus an optional reply-to address.
 *
 * The field name is `replyTo` (not `fromEmail`) — this preserves verbatim the request shape the
 * legacy inline dialog sent, so the api-service contract is untouched (ui#149 was presentation-only).
 * `replyTo` is an empty string when the sender chose not to leave an address.
 */
export interface FeedbackRequest {
	message: string;
	replyTo: string;
}

/**
 * Support/Feedback service (house `*Api.ts` axios pattern, see `account/AccountApi.ts`). Holds the
 * single HTTP call the {@link useFeedback} hook drives, so the dialog view stays dumb (epic #26).
 */
export class FeedbackApi {
	/** POSTs the note to `/feedback`. Resolves on 2xx, rejects on any transport/HTTP error. */
	static async send(request: FeedbackRequest): Promise<void> {
		await axios.post("/feedback", request);
	}
}
